import _ from "lodash";
import React, { useEffect, useState } from "react";
import {
  Card,
  createStyles,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import CardCommon from "../../../../../components/card/CardCommon";
import { CustomTheme } from "../../../../../types/customTheme";

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    cardStyle: {
      height: "40px",
      boxShadow: "none",
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.background.paper,
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      },
      "&:nth-of-type(even)": {
        backgroundColor: theme.palette.background.entity_background,
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
  }),
);

export interface AvailabilitySelectionModalProps {
  shiftReportNode: any;
}

/* This creates the banking and summery tables. This component only works if the key is banking or summery. */
const BankingAndSummeryInfo: React.FunctionComponent<
  AvailabilitySelectionModalProps
> = ({ shiftReportNode }) => {
  const [reportName, setTableName] = useState("");
  const [nodes, setNodes] = useState<any>([]);

  useEffect(() => {
    const { tableName, data } = shiftReportNode;
    setTableName(tableName);
    setNodes(data);
  }, [shiftReportNode]);

  const classes = useStyles();

  return (
    <div style={{ margin: "16px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          marginBottom: "12px",
          marginLeft: "2px",
        }}
      >
        <Typography variant="h6">{reportName}</Typography>
      </div>
      <CardCommon>
        {!_.isEmpty(nodes) &&
          nodes.map((data: any) => (
            <Card className={classes.cardStyle}>
              <Grid container style={{ placeItems: "center", height: "40px" }}>
                <Grid
                  item
                  xs={6}
                  style={{ paddingLeft: "16px", fontWeight: "bold" }}
                >
                  {data.Title}
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{
                    paddingRight: "16px",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  {data.Amount}
                </Grid>
              </Grid>
            </Card>
          ))}
      </CardCommon>
    </div>
  );
};

export default BankingAndSummeryInfo;
